import { createSlice } from "@reduxjs/toolkit";

// Initial state
const initialState = {
  data: {
    business: null,
    reportData: [],
    summary: {
      totalSales: 0,
      totalTransactions: 0,
      dateRange: {
        start: null,
        end: null,
        frequency: "daily",
      },
      searchCriteria: {
        field: null,
        query: null,
      },
    },
  },
  loading: false,
  error: null,
};

const customerPurchaseReportSlice = createSlice({
  name: "customerPurchaseReport",
  initialState,
  reducers: {
    customerPurchaseReportRequest(state) {
      state.loading = true;
      state.error = null;
    },
    customerPurchaseReportSuccess(state, action) {
      state.loading = false;
      state.data = action.payload.data; // Matches { business, reportData, summary }
    },
    customerPurchaseReportFailure(state, action) {
      state.loading = false;
      state.error = action.payload; // Error message
    },
    resetCustomerPurchaseReport(state) {
      state.loading = false;
      state.error = null;
      state.data = initialState.data;
    },
  },
});

// Export actions and reducer
export const {
  customerPurchaseReportRequest,
  customerPurchaseReportSuccess,
  customerPurchaseReportFailure,
  resetCustomerPurchaseReport,
} = customerPurchaseReportSlice.actions;

export default customerPurchaseReportSlice.reducer;